import { FlyerLayoutAbstract } from './flyer-layout.abstract'
import moment from 'moment-timezone'

export default class Flyer_layout_split_t_039LayoutModel extends FlyerLayoutAbstract {
  flourishes = [
    {
      name: 'hexagons',
      left: 0,
      top: 0,
      width: 320,
      height: 568
    }
  ]

  textLayouts = {
    event_name_1: {
      top: 237,
      left: 40,
      size: 37,
      width: 240,
      height: 43.5,
      align: 'center'
    },
    location_1: {
      top: 297,
      left: 75,
      size: 17,
      width: 170,
      height: 20,
      align: 'center',
      overflow: 1
    },
    location_2: {
      top: 315,
      left: 75,
      size: 16,
      width: 170,
      height: 12,
      align: 'center',
      overflow: 1
    }
  }

  dateLayouts = {
    date_1: {
      top: 199,
      left: 75,
      daySize: 14,
      height: 16.5,
      width: 170,
      align: 'center'
    }
  }

  constructor(flyerDesign, eventData) {
    super(flyerDesign, eventData)
    this.init()
  }

  getLocationText2() {
    const { starts_at, ends_at, timezone, venue } = this.eventData
    if (!starts_at) return ''

    const start = moment.tz(starts_at, timezone || 'UTC')
    const end = ends_at ? moment.tz(ends_at, timezone || 'UTC') : null

    if (!venue) {
      if (end && !start.isSame(end, 'day')) {
        return `${this.stripZerosForHour(start.format('MMM D, h:mma'))} - ${this.stripZerosForHour(end.format('MMM D, h:mma'))}`
      } else if (end) {
        return `${this.stripZerosForHour(start.format('h:mma'))} - ${this.stripZerosForHour(end.format('h:mma'))}`
      } else {
        return this.stripZerosForHour(start.format('MMM D, h:mma'))
      }
    }

    return ''
  }

  dayShortSuffixForDate(date) {
    const d = moment(date).date()
    if (d > 3 && d < 21) return 'TH'
    switch (d % 10) {
      case 1: return 'ST'
      case 2: return 'ND'
      case 3: return 'RD'
      default: return 'TH'
    }
  }

  stripZerosForHour(timeStr) {
    return timeStr.replace(/^0+/, '')
  }

  getDateTexts() {
    const startDate = this.eventData.starts_at
    const endDate = this.eventData.ends_at
    const timeZone = this.eventData.timezone || 'UTC'
    const venue = this.eventData.venue

    const date1 = this.dateLayouts.date_1

    const safeDate1Color = this.dateProps.date1Props?.color?.replace('0x', '#') || '#cccccc'
    const safeDate1Font = this.dateProps.date1Props?.font?.replace(/\s+/g, '-') || 'Arial'

    let dates = []

    if (!startDate) return { type: 'date', dates }

    const start = moment.tz(startDate, timeZone)
    const end = endDate ? moment.tz(endDate, timeZone) : null

    const hasLocation = !!venue

    let startDateLabel = ''

    if (!hasLocation) {
      if (end && !start.isSame(end, 'day')) {
        const startDay = start.format('dddd')
        const endDay = end.format('dddd')
        startDateLabel = `${startDay} - ${endDay}`
      } else {
        startDateLabel = start.format('dddd')
      }
    } else {
      if (end) {
        if (start.isSame(end, 'day')) {
          startDateLabel = `${start.format('dddd MMM D, h:mma')}-${this.stripZerosForHour(end.format('h:mma'))}`
        } else {
          startDateLabel = `${start.format('ddd, MMM D')}-${end.format('ddd, MMM D')}`
        }
      } else {
        startDateLabel = start.format('dddd, MMM D, h:mma')
      }
      startDateLabel = this.stripZerosForHour(startDateLabel)
    }

    dates.push({
      text: startDateLabel,
      align: date1.align,
      width: date1.width,
      height: date1.height,
      left: date1.left,
      top: date1.top,
      color: safeDate1Color,
      font: safeDate1Font,
      size: date1.daySize
    })

    return { type: 'date', dates }
  }
}
